export default __webpack_public_path__ + "static/media/apple-store.2ea5183d.svg";